export default __webpack_public_path__ + "static/media/GoodQuality.fca9f984.svg";